/*
 * Copyright (c) Nexign, JSC, 2019-2022.
 */
/**
 *
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.1.0
 */
import type { FC } from 'react';

import getCellValue from '@components/Table/helpers/getCellValue';

import {
    TableDateStyled,
    TableTextDefaultValueStyled,
    TableTextTooltipStyled,
} from '../styled/TableBlockStyled';

export interface ITableDoubleTextBlockProps {
    defaultValue: string;
    secondValue: string;
}

const TableDoubleTextBlock: FC<ITableDoubleTextBlockProps> = props => {
    const value = getCellValue(props.children);
    return (
        <>
            {
                value ?
                    <>
                        <TableTextTooltipStyled>
                            {value}
                        </TableTextTooltipStyled>
                        <TableTextTooltipStyled>
                            <TableDateStyled>
                                {props.secondValue}
                            </TableDateStyled>
                        </TableTextTooltipStyled>
                    </>
                    :
                    <TableTextDefaultValueStyled>
                        {props.defaultValue}
                    </TableTextDefaultValueStyled>
            }
        </>
    );
};

TableDoubleTextBlock.defaultProps = {
    defaultValue: '',
};

export default TableDoubleTextBlock;
